import { apiGrupoEntrada, apiGrupoSalida } from "../API";
import { _APP_DATA } from "../AppData";
import { IApiResult } from "../models/Entities";
import { RequestData } from "../utils/RequestData";

export function _SvGrupoEntrada(childId: number, groupId?: number, callback?: (status: number) => void): void {
    let params = {
        IdAlumno: childId,
        IdGrupo: groupId || _APP_DATA.userData.IdGrupo,
        IdUsuario: _APP_DATA.userData.IdUsuario
    };

    new RequestData<IApiResult<any>>(apiGrupoEntrada)
        .Params(params)
        .Completion((response, error) => {
            let status = response ? response.Resultado : -111;
            if (error)
                console.log(error.name, error.message);

            if (callback) callback(status);
        }).Post();
}

export function _SvGrupoSalida(idChild: number, group: number, callback?: (status: number) => void): void {
    let params = {
        IdAlumno: idChild,
        IdGrupoSiguiente: group,
        IdUsuario: _APP_DATA.userData.IdUsuario
    };

    new RequestData<IApiResult<any>>(apiGrupoSalida)
        .Params(params)
        .Completion((response, error) => {
            let status = response ? response.Resultado : -111;
            if (error)
                console.log(error.name, error.message);

            if (callback) callback(status);
        }).Post();
}

